<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-24
    	描述：后台母版
    -->
  <div :class="hasChild != null ? 'main' : 'main right-big'">
    <!--left menu-->
    <!-- class="hidden-xs-only" -->
    <LeftMenu @selectMenu="selectMenuFunc"></LeftMenu>

    <!--right content-->
    <!-- class="hidden-xs-only" -->
    <RightContent></RightContent>

    <!-- 手机端显示 -->
    <!-- <Phone class="hidden-1g-and-up"></Phone> -->

  </div>
</template>

<script>
import Phone from '@/views/layout/phone.vue';
import 'element-ui/lib/theme-chalk/display.css';
import LeftMenu from '@/views/layout/LeftMenu.vue';
import RightContent from '@/views/layout/RightContent.vue';
import store from '@/store/';
import { delCookie } from '@/utils/base.js';
export default {
  components: {
    /*左菜单组件*/
    LeftMenu,
    /*右边内容容器*/
    RightContent,
    Phone,
  },
  data() {
    return {
      /*是否有子菜单*/
      hasChild: null,
      /*系统基本数据*/
      baseInfo: {
        shop_name: '',
        user: {},
        version: '',
        role: ''
      }
    };
  },
  provide: function () {
    return {
      baseInfo: this.baseInfo
    };
  },
  created() {
    if (this.$route.query.from && this.$route.query.from == 'admin') {
      delCookie('baseInfo');
    }

    this.getBaseInof();
  },
  methods: {
    /*左边子组件传来的参数*/
    selectMenuFunc(param) {
      this.hasChild = param;
    },

    async getBaseInof() {
      let res = await store.dispatch('common/getBaseInfo');
      console.log(res);
      this.baseInfo.shop_name = res.shop_name;
      this.baseInfo.version = res.version;
      this.baseInfo.user = res.user;
      this.baseInfo.role = res.role != '' ? res.role[0].role_id : '';
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/layout/main.vue